export default __webpack_public_path__ + "static/media/store.9c8e16c3.jpg";